import { ValidationMessage } from "@/models/validation-message";
import { z } from "zod";
import { getNameAndPhoneSchema } from "./name-and-phone-schema";

export const getCreateServiceOrderSchema = () =>
  z.object({
    title: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    facilityName: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    address: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    postAddress: z.string().nonempty({ message: ValidationMessage.NON_EMPTY }),
    coordinates: z
      .object({
        x: z
          .string()
          .nonempty({ message: ValidationMessage.NON_EMPTY })
          .optional(),
        y: z
          .string()
          .nonempty({ message: ValidationMessage.NON_EMPTY })
          .optional(),
      })
      .optional(),
    orderNumber: z.string().optional(),
    description: z.string().optional(),
    customerReference: z.string().optional(),
    customer: getNameAndPhoneSchema(),
  });
